import gql from 'graphql-tag'
import {
    CreateGroupSession,
    CreateGroupSessionMutation as CreateMutation,
    CreateGroupSessionMutationVariables as CreateMutationVars,
    UpdateGroupSession,
    UpdateGroupSessionMutation as UpdateMutation,
    UpdateGroupSessionMutationVariables as UpdateMutationVars,
    DeleteGroupSessionMutation as DeleteMutation,
    DeleteGroupSessionMutationVariables as DeleteMutationVars,
    AddGroupSessionAttendeeMutation as AddAttendeeMutation,
    AddGroupSessionAttendeeMutationVariables as AddAttendeeMutationVars,
    AddGroupSessionAttendee as AddAttendee,
    RemoveGroupSessionAttendee as RemoveAttendee,
    RemoveGroupSessionAttendeeMutation as RemoveAttendeeMutation,
    RemoveGroupSessionAttendeeMutationVariables as RemoveAttendeeMutationVars
} from 'generated/graphql'
import graphql from 'utils/graphql'

// Create group session
const createGroupSessionMutation = gql`
    mutation createGroupSession($data: CreateGroupSession!) {
        createGroupSession(data: $data) {
            id
        }
    }
`
export const createGroupSession = (data: CreateGroupSession) => {
    const query = graphql.createQuery<CreateMutation, CreateMutationVars>(createGroupSessionMutation)
    return query({ data })
}

// Update group session
const updateGroupSessionMutation = gql`
    mutation updateGroupSession($id: ID!, $data: UpdateGroupSession!) {
        updateGroupSession(id: $id, data: $data) {
            id
        }
    }
`
export const updateGroupSession = (id, data: UpdateGroupSession) => {
    const query = graphql.createQuery<UpdateMutation, UpdateMutationVars>(updateGroupSessionMutation)
    return query({ id, data })
}

// Delete group session
const deleteGroupSessionMutation = gql`
    mutation deleteGroupSession($id: ID!) {
        deleteGroupSession(id: $id)
    }
`
export const deleteGroupSession = (id) => {
    const query = graphql.createQuery<DeleteMutation, DeleteMutationVars>(deleteGroupSessionMutation)
    return query({ id })
}

// Add group session attendee
const addAttendeeMutation = gql`
    mutation addGroupSessionAttendee($data: AddGroupSessionAttendee!) {
        addGroupSessionAttendee(data: $data) {
            about
            company
            email
            firstName
            hasLoggedOn
            id
            jobtitle
            lastName
            mugshot
        }
    }
`
export const addGroupSessionAttendee = (data: AddAttendee) => {
    const query = graphql.createQuery<AddAttendeeMutation, AddAttendeeMutationVars>(addAttendeeMutation)
    return query({ data })
}

// Remove group session attendee
const removeAttendeeMutation = gql`
    mutation removeGroupSessionAttendee($data: RemoveGroupSessionAttendee!) {
        removeGroupSessionAttendee(data: $data)
    }
`
export const removeGroupSessionAttendee = (data: RemoveAttendee) => {
    // eslint-disable-next-line max-len
    const query = graphql.createQuery<RemoveAttendeeMutation, RemoveAttendeeMutationVars>(removeAttendeeMutation)
    return query({ data })
}
